/* Rich-Text-Links: automatischer title = H1/Titel der verlinkten Seite.
   - Greift nur bei .rte-Links OHNE eigenes title-Attribut (manueller Titel gewinnt).
   - Nur interne (same-origin) Links; Auflösung lazy bei Hover, pro URL gecacht.
   - Produkte über /products/handle.js (leicht), sonst Seite laden + H1/<title> lesen. */
(function () {
  'use strict';
  var cache = Object.create(null);

  function fetchTitle(href) {
    if (cache[href]) return cache[href];
    var u;
    try { u = new URL(href, location.origin); } catch (e) { return (cache[href] = Promise.resolve('')); }
    if (u.origin !== location.origin) return (cache[href] = Promise.resolve('')); // extern → nichts
    var prod = u.pathname.match(/\/products\/([^\/?#]+)/);
    var p;
    if (prod) {
      p = fetch('/products/' + prod[1] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.title ? j.title : ''; });
    } else {
      p = fetch(u.pathname)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var h1 = doc.querySelector('main h1, h1');
          return (h1 && h1.textContent.trim()) || (doc.title || '').trim();
        });
    }
    p = p.catch(function () { return ''; });
    cache[href] = p;
    return p;
  }

  function onEnter(e) {
    var a = e.currentTarget;
    a.removeEventListener('mouseenter', onEnter);
    if (a.getAttribute('title')) return;
    fetchTitle(a.href).then(function (t) { if (t && !a.getAttribute('title')) a.setAttribute('title', t); });
  }

  function init() {
    var links = document.querySelectorAll('.rte a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('title')) continue;                 // manueller Titel gewinnt
      var href = a.getAttribute('href') || '';
      if (!/^https?:|^\//.test(href)) continue;               // nur echte URLs (keine mailto:/tel:/#)
      a.addEventListener('mouseenter', onEnter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
